const ACC_INJURY_TOOTH_DAMAGE_DEGREE_TERM = 'ACCPermanentInjuryToothDamageCovCovPIDegree';
const ACC_INJURY_TOOTH_DAMAGE_SUM_INSURED_TERM = 'ACCPermanentInjuryToothDamageCovSumInsured';
const ACC_INJURY_TOOTH_DAMAGE_FIVE_PERCENT = 5;
const ACC_INJURY_TOOTH_DAMAGE_EIGHT_PERCENT = 8;
const CHILD_INJURY_TOOTH_DAMAGE_SUM_INSURED_TERM = 'ACCChildPermInjAccCovSumInsured';
const ACC_DEATH_COVERAGE_TERM = 'ACCDeathCovSumInsured';

export {
    ACC_INJURY_TOOTH_DAMAGE_DEGREE_TERM,
    ACC_INJURY_TOOTH_DAMAGE_SUM_INSURED_TERM,
    ACC_INJURY_TOOTH_DAMAGE_FIVE_PERCENT,
    ACC_INJURY_TOOTH_DAMAGE_EIGHT_PERCENT,
    CHILD_INJURY_TOOTH_DAMAGE_SUM_INSURED_TERM,
    ACC_DEATH_COVERAGE_TERM
};
